import { avatarColorFor } from '../roleTaxonomy';

interface UserAvatarProps {
  name: string;
  size?: number;
  /** Override the deterministic color. */
  color?: string;
}

/** Round initials avatar. Color is deterministic from the name unless given. */
export default function UserAvatar({ name, size = 28, color }: UserAvatarProps) {
  const initials = (name || '?')
    .split(/\s+/)
    .map((p) => p[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();

  return (
    <span
      className="inline-flex items-center justify-center rounded-full text-white font-bold flex-none"
      style={{
        width: size,
        height: size,
        background: color || avatarColorFor(name),
        fontSize: Math.round(size * 0.38),
        letterSpacing: '.02em',
      }}
    >
      {initials}
    </span>
  );
}
